import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
import * as fromRoot from '../../../../../../../../../state/app.state';
import { projectDetails } from '../../../../../../../core/projects.selectors';
import { appDataDetails } from '../../../../../../../../../shared/core/shared.selectors';

@Component({
  standalone: false,
  selector: 'app-cle-equipment-summary',
  templateUrl: './cle-equipment-summary.component.html',
  styleUrls: ['./cle-equipment-summary.component.scss'],
})
export class CleEquipmentSummaryComponent implements OnInit, OnDestroy {
  @Input() data: any;
  matchedId: any;
  matchedNo: any;
  widgetIds: any = [];
  displayMatched: boolean;
  displayName: string = '';
  private allContractors: any[] = [];
  private genericEquipmentList: any[] = [];
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private store: Store<fromRoot.State>,
  ) {
  }

  ngOnInit() {
    this.store.select(projectDetails)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(project => {
        this.allContractors = project?.sub_contractors || [];
        this.resolveDisplayName();
      });

    this.store.select(appDataDetails)
      .pipe(takeUntil(this.onDestroy))
      .subscribe((data: any) => {
        this.genericEquipmentList = data?.genericEquipment || [];
        this.resolveDisplayName();
      });

    this.route.queryParams
      .pipe(takeUntil(this.onDestroy))
      .subscribe(qp => {
        if (qp && qp['matchedId']) {
          this.matchedId = qp['matchedId'];

          if (!Array.isArray(this.matchedId)) {
            this.matchedId = [this.matchedId];
          }

          if (this.matchedId?.length) {
            this.matchedId?.forEach((item) => {
              this.widgetIds?.push(item?.split('_')?.[1]);
            });
          }

          const tempData = this.matchedId?.filter((item) => {
            const parts = item?.split('_');
            return parts?.length === 3 && parts[1] === this.data?.id;
          });
          this.matchedNo = tempData[0]?.split('_')?.[2];
        }

        this.setDisplayMatched();
      });
  }

  resolveDisplayName() {
    if (!this.data?.source_id) {
      return;
    }

    if (this.data?.source_type === 'equipment') {
      for (const contractor of this.allContractors) {
        const eq = contractor?.equipment?.find(e => e.id === this.data.source_id || e.value === this.data.source_id);
        if (eq) {
          this.displayName = [eq.name, eq.description].filter(Boolean).join(' - ');
          this.cdRef.detectChanges();
          return;
        }
      }
    } else if (this.data?.source_type === 'genericEquipment') {
      const ge = this.genericEquipmentList.find(g => g.id === this.data.source_id || g.value === this.data.source_id);
      if (ge) {
        this.displayName = [ge.name, ge.description].filter(Boolean).join(' - ');
        this.cdRef.detectChanges();
        return;
      }
    }
  }

  setDisplayMatched() {
    if (this.data?.id && this.widgetIds?.length) {
      if (this.widgetIds?.includes(this.data?.id)) {
        this.displayMatched = true;
      }
    }

    this.cdRef.detectChanges();
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
